import { useState, useEffect, useCallback } from 'react'
import { FormattedMessage } from 'react-intl'
import { useFormik } from 'formik'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import CircularProgress from '@mui/material/CircularProgress'
import FormikEditorField from '../../../../shared/components/formik/FormikEditorField'

function ProjectYamlTab({ getCompose, updateCompose, active }) {
  const [loading, setLoading] = useState(false)
  const [loaded, setLoaded] = useState(false)

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      compose: ''
    },
    onSubmit: (values, { setSubmitting, setStatus }) => {
      updateCompose({ compose: values.compose })
        .then(() => {
          setStatus(null)
        })
        .catch((err) => {
          setStatus(err.message || 'Error saving compose')
        })
        .finally(() => {
          setSubmitting(false)
        })
    }
  })

  const loadCompose = useCallback(() => {
    if (loaded) return
    setLoading(true)
    getCompose()
      .then((response) => {
        formik.setFieldValue('compose', response.compose || '')
        setLoaded(true)
      })
      .catch(() => {
        formik.setFieldValue('compose', '')
      })
      .finally(() => {
        setLoading(false)
      })
  }, [loaded, getCompose, formik])

  useEffect(() => {
    if (active && !loaded) {
      loadCompose()
    }
  }, [active, loaded, loadCompose])

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress size={24} />
      </Box>
    )
  }

  if (!loaded) {
    return (
      <Typography color="text.secondary">
        <FormattedMessage id="dockerProjects.error" />
      </Typography>
    )
  }

  return (
    <Box component="form" onSubmit={formik.handleSubmit}>
      <FormikEditorField
        formik={formik}
        name="compose"
        language="yaml"
        height="60vh"
      />
      {formik.status && (
        <Typography color="error" sx={{ mt: 1 }}>
          {formik.status}
        </Typography>
      )}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
        <Button
          variant="contained"
          type="submit"
          disabled={formik.isSubmitting}
        >
          {formik.isSubmitting ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            <FormattedMessage id="dockerProjects.compose.saveButton" />
          )}
        </Button>
      </Box>
    </Box>
  )
}

export default ProjectYamlTab
